import React from 'react';
import ReactDOM from 'react-dom';
import CorePage from './CorePage';
import BrowserUtil from '../../util/BrowserUtil';
import BrowserStorageUtil from '../../util/BrowserStorageUtil';
import HmEventRegistry from './../../model/HmEventRegistry';
import NativeAjax from '../../util/NativeAjax';
import HawkEye from '../../util/HawkEye';
import UserStore from '../../util/UserStore';

export default class LoggedOutPrompt extends CorePage{
  constructor(props) {
    super(props);
    this.userObj = {};
    this.UserStore = new UserStore();
    this.doCommonLogout = this.doCommonLogout.bind(this);
  };
  showPrompt(){
    let me = this;
    var PLPToken =  BrowserUtil.getCookie('_rToken');
    var LumosToken =  BrowserUtil.getCookie('authToken');
    var buttons = [{
      label: this.props.exit ? this.rb("home.btn.close") : this.rb("login"),
      handler: () => {
        if(this.props.exit){            		
          window.close();
        }else if((PLPToken || LumosToken ) != "") {
          me.doCommonLogout();
        }else{
          window.location.href= me.getPostLogoutUrl();
        }
      }

    }]
    this.showAlert(this.rb("logged_out_label"), this.rb("logged_out_desc"), buttons);

  }

  getPostLogoutUrl(){
    let redirectUrl = null;
    /*if(BrowserUtil.getCookie("loginSrc") && BrowserUtil.getCookie("loginSrc").length > 10){
      redirectUrl = (BrowserUtil.getCookie("loginSrc")).replace(/"/g,"");
    }else if(BrowserStorageUtil.getStoredItem("loginSrc") && BrowserStorageUtil.getStoredItem("loginSrc").length > 10){
      redirectUrl = (BrowserStorageUtil.getStoredItem("loginSrc")).replace(/"/g,"");
      BrowserStorageUtil.removeItem("loginSrc");
    }else */
    if(this.getUrlFor("PRELOGIN_PAGE") && this.getUrlFor("PRELOGIN_PAGE").length > 0){
      redirectUrl = (this.getUrlFor("PRELOGIN_PAGE")).replace(/"/g,"");
    }else if(this.getUrlFor("HEYMATH_HOME") && this.getUrlFor("HEYMATH_HOME").length > 0){
      redirectUrl = (this.getUrlFor("HEYMATH_HOME")).replace(/"/g,"");
    }

    return redirectUrl;
  }

  doCommonLogout(){
    var me = this;
    var callBackSuccess = function(){

      me.initiateTrack("logout",{});

      setTimeout(function(){
        me.UserStore.clearOldUser();
        window.location.href = me.getPostLogoutUrl()+"?loginForm=lumos";
      },500);

    }

    var PLPcallBackFailure = function(){
      window.location.href = me.getPostLogoutUrl();
      console.error("Logout failed.");
    }

    var callBackFailure = function(response,request){
      if(request.status!=403){
        new NativeAjax(me.getUrlFor("PLP_COMMON_LOGOUT")).enableCORS().get(callBackSuccess, PLPcallBackFailure);
      }else{
       window.location.href = me.getPostLogoutUrl();
     }
     console.error("Logout failed.");
   }
   new NativeAjax(this.getUrlFor("LUMOS_COMMON_LOGOUT")).enableCORS().get(callBackSuccess, callBackFailure);
 }

 initiateTrack(trackKey,addnldata){		
   var me = this;	
   var trackObj = me.getTracker().getEventObject(me.getTracker().eventCodes[trackKey]);
   trackObj.event_details.user_id = me.userObj.userId || "";
   trackObj.event_details.session_id = me.userObj.authToken || "";
   trackObj.event_details.timestamp = new Date().getTime() || "";


   if(addnldata !== undefined && typeof addnldata === "object"){
    for(var key in addnldata){
      trackObj.event_data[key] = addnldata[key];
    }
  }

  var output = {"event":trackObj};
  new HawkEye(output).post();
}

render() {
 return(
   <div styles={{backgroundColor: '#ccc',position: 'absolute',top: 0,left: 0,width: '100vw',height: '100vh',zIndex: 10,opacity: 0.5}}>
   {this.showPrompt()}
   </div>
   )
 }
}

HmEventRegistry.registerEvent("LOG_OUT_PROMPT",function(obj){
	ReactDOM.render(<LoggedOutPrompt />, document.getElementById('root'));	
});

HmEventRegistry.registerEvent("LOG_OUT_PROMPT_EXIT",function(obj){
	ReactDOM.render(<LoggedOutPrompt exit={true}/>, document.getElementById('root'));	
});


// WEBPACK FOOTER //
// ./src/views/core/LoggedOutPrompt.js